// extracted by mini-css-extract-plugin
export default {"tabHead":"index_tabHead_8prYV","tabHeadItem":"index_tabHeadItem_SOGYd","current":"index_current_ndiMO","fix":"index_fix_MkTcB"};